import React from "react";
import { Star } from "lucide-react";

export default function AmbassadorBanner({ hubName }: { hubName: string }) {
  return (
    <div
      className="rounded-2xl overflow-hidden mb-5"
      style={{
        background:
          "linear-gradient(135deg, rgb(21, 65, 94) 0%, rgb(30, 89, 109) 100%)",
      }}
    >
      <div className="flex items-start gap-4 p-5">
        <div className="w-10 h-10 rounded-lg bg-black/20 flex items-center justify-center shrink-0">
          <Star className="text-amber-400 fill-amber-400" size={20} />
        </div>
        <div className="min-w-0">
          <h2 className="font-bold text-white text-base md:text-lg">
            You&apos;re an Ambassador for {hubName}
          </h2>
          <p className="text-white/80 text-sm mt-1 leading-relaxed">
            You can post, moderate comments, and add members.
          </p>
        </div>
      </div>
    </div>
  );
}
